<template>
    <header :class="{sticky: stickyHeader}">
        <a :href="$t('main.site_root')" class="home-logo">
            <img :alt="$t('main.museum_name')" :src="`${$rootUrl()}${$t('main.museum_name_img')}`"/>
        </a>

        <button id="toggle-btn"
                class="menu-toggle"
                :class="{toggled: showMenu}"
                @click="showMenu = !showMenu"
                :aria-expanded="showMenu"
                aria-labelledby="menu-toggle-id"
                aria-controls="main-menu">
            <p class="sr-only" id="menu-toggle-id">{{ $t('menu.main_menu') }}</p>
            <span class="menu-icon"></span>
        </button>
        <div id="main-menu" class="links" :class="{toggled: showMenu}">
            <a :href="$rootUrl()" id="home-btn" class="navLabel">{{$t('menu.home')}}</a>

            <span id="language-switcher">
                <a href="https://www.warmuseum.ca/tilston-medals-collection/" v-if="$i18n.locale !== 'en'" to="/">
                    English
                </a>
                <a href="https://www.museedelaguerre.ca/collection-medailles-tilston/" v-else>
                    Français
                </a>
            </span>
            <router-link :to="{name: 'recipients'}" class="nav-link">{{ $t('menu.recipients') }}</router-link>
            <router-link :to="{name: 'medals'}" class="nav-link">{{ $t('menu.medals') }}</router-link>
            <router-link id="last-link" :to="{name: 'themes'}" class="nav-link">{{ $t('menu.themes') }}</router-link>
        </div>

    </header>
</template>

<script>
export default {
    name: "Header",
    data () {
        return {
            showMenu: false,
            addListeners: true
        }
    },
    computed: {
        stickyHeader () {
            return this.$route.name == 'index';
        }
    },
    methods: {
        restrictMenuTabs: function () {
            let menuWrapper = document.querySelector('header');
            let keysPressed = {};
            let header = this;

            menuWrapper.addEventListener('keydown', function (e) {
                keysPressed[e.key] = true;

                let toggleBtn = e.target.id == 'toggle-btn';
                let lastLink = e.target.id == 'last-link';

                if (toggleBtn && header.showMenu) {
                    if (keysPressed['Tab'] && keysPressed['Shift']) {
                        e.preventDefault();
                    };
                } else if (lastLink) {
                    if (keysPressed['Tab'] && !keysPressed['Shift']) {
                        e.preventDefault();
                    };
                }
            });

            menuWrapper.addEventListener('keyup', e => {
                if (keysPressed[e.key]) keysPressed[e.key] = false;
            });
        }
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                this.showMenu = false;
            }
        }
    },
    mounted () {
        if (this.addListeners) {
            this.restrictMenuTabs();
        }
        this.addListeners = false;
    }
}
</script>

<style lang="scss" scoped>

$tan: #edece8;

header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $tan;
    padding: 10px;
    padding-right: 25px;
    box-sizing: border-box;

    &.sticky {
        height: 60px;
        position: -webkit-sticky;
        position: sticky;
        top: -0;
    }
}

.home-logo {
    img {
        width: 300px;
        height: 36px;
    }

    @media screen and (max-width: 415px)  {
        img {
            width: 180px;
            height: auto;
        }
    }
}

a {
    font-family: 'FuturaBold', Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: bold;
    text-decoration: none;
    color: #212529;
    position: relative;
    display: inline-block;
    margin: 0 13px;
}

a:not(.home-logo):hover:after {
    content: "";
    border-bottom: solid 1px #212529;
    width: 100%;
    height: 4px;
    display: block;
    position: absolute;
    top: 20px;
}

.nav-link {
    display: none;
}

.menu-toggle {
    cursor: pointer;
    display: none;
    z-index: 3;
    position: fixed;
    top: 10px;
    right: 10px;
    border: none;
    background: $tan;
    padding: 5px 8px 0 0;
    height: 40px;
    width: 40px;
}


.menu-icon:after {
    content: url('../assets/icons/menu.svg');
    width: 38px;
    height: 25px;
    display: block;
}

@media screen and (max-width: 920px) {
    .links {
        background-color: $tan;
        width: 100%;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-end;
        position: fixed;
        top: 60px;
        right: 0;
        z-index: 2;
        height: 50%;
        max-height: 300px;
        padding: 0;
        display: none;
        border-bottom: solid 1px #1f272e;

        &.toggled {
            display: flex;
            height: 50%;
        }
    }

    .nav-link {
        display: inline-block;
        position: relative;
    }

    .menu-toggle {
        display: block;
    }
}

</style>

